<template>
	<AsiDialogFormLayout :icon="icons.customer" :title="$t('customer.terms.create')"
	                     :open="open" :loading="loading" :valid="valid" :errors="errors" @cancel="cancel"
	                     unwrapped scrollable :save-button-visible="false" :cancel-label="$t('ui.close')" max-width="70%">
		<CustomerCreateWizard/>
	</AsiDialogFormLayout>
</template>

<script lang="ts">
	import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
	import {Component, Emit} from "vue-property-decorator";
	import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";
	import RegistrationWizard from "@/components/user/shop/RegistrationWizard.vue";
	import CustomerCreateWizard from "@/components/customer/admin/CustomerCreateWizard.vue";
	import CustomerCreate from "@/models/customer/CustomerCreate";

	@Component({
		components: {CustomerCreateWizard, RegistrationWizard, AsiDialogFormLayout}
	})
	export default class CustomerCreateDialog extends AsiDialogForm {

		private model: CustomerCreate = new CustomerCreate();
		@Emit('cancel')
		public cancel(event: Event): Event {
			const form = this.$refs.form as HTMLFormElement;
			this.reset([this.model], form);
			return event;
		}

	}
</script>

<style lang="scss" scoped>

</style>
